var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageCircle = function SvgMessageCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 46.0001C84.0138 51.2796 82.7803 56.4877 80.4 61.2001C77.5777 66.8471 73.239 71.5968 67.8698 74.9172C62.5006 78.2377 56.313 79.9977 50 80.0001C44.7205 80.0139 39.5125 78.7804 34.8 76.4001L12 84.0001L19.6 61.2001C17.2197 56.4877 15.9862 51.2796 16 46.0001C16.0024 39.6871 17.7624 33.4995 21.0829 28.1303C24.4033 22.7611 29.153 18.4224 34.8 15.6001C39.5125 13.2198 44.7205 11.9863 50 12.0001H52C60.3374 12.4601 68.2122 15.9792 74.1166 21.8835C80.021 27.7879 83.54 35.6627 84 44.0001V46.0001Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMessageCircle;